import { t } from '@lingui/core/macro';
import { NumberRangeFilter } from './NumberRangeFilter';
export const liabilityCapFilterLabel = () => t({
    message: 'Liability cap',
    comment: 'Insights: Liability cap filter',
});
export function LiabilityCapFilter() {
    return <NumberRangeFilter name="metadataDocumentLiabilityCap" label={liabilityCapFilterLabel()}/>;
}
